var React = require('react');

function Album (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M561,408V51c0-28.05-22.95-51-51-51H153c-28.05,0-51,22.95-51,51v357c0,28.05,22.95,51,51,51h357\n\t\tC538.05,459,561,436.05,561,408z M242.25,267.75l63.75,76.5l89.25-114.75L510,382.5H153L242.25,267.75z M0,102v408\n\t\tc0,28.05,22.95,51,51,51h408v-51H51V102H0z"}));
}

Album.defaultProps = {"version":"1.1","width":"561px","height":"561px","viewBox":"0 0 561 561"};

module.exports = Album;

Album.default = Album;
